/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DailyOrgSummaryPaginatedResponse } from '../model/dailyOrgSummaryPaginatedResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OrgTelemetryVcdrService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get daily org usage summary by filters
     * Get daily org usage summary by filters
     * @param orgId Organization identifier
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the daily org summary usage by this column
     * @param usageDate Date for usage summary in YYYY-MM-DD
     * @param startUsageDate start date for usage summary in YYYY-MM-DD
     * @param endUsageDate end date for usage summary in YYYY-MM-DD
     * @param pageNoNullableOptional Page Number (It starts from 0)
     * @param pageSizeNullableOptional Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgDailySummaryVcdr(orgId: string, sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', usageDate?: string, startUsageDate?: string, endUsageDate?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryPaginatedResponse>;
    public getOrgDailySummaryVcdr(orgId: string, sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', usageDate?: string, startUsageDate?: string, endUsageDate?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryPaginatedResponse>>;
    public getOrgDailySummaryVcdr(orgId: string, sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', usageDate?: string, startUsageDate?: string, endUsageDate?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryPaginatedResponse>>;
    public getOrgDailySummaryVcdr(orgId: string, sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', usageDate?: string, startUsageDate?: string, endUsageDate?: string, pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getOrgDailySummaryVcdr.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usageDate, 'usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startUsageDate, 'start-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endUsageDate, 'end-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNoNullableOptional, 'page-no-nullable-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSizeNullableOptional, 'page-size-nullable-optional');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/org-summary/daily-usage-summary`;
        return this.httpClient.request<DailyOrgSummaryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
